import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgOverheadStorage = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 22,
  height: 21,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11 11.96 4.354 4.353-.708.707-3.147-3.146L11.5 21h-1v-7.126L7.353 17.02l-.708-.707L11 11.96ZM22 9v1H0V9h22Zm-5-9a1 1 0 0 1 .993.883L18 1a1 1 0 0 1 .117 1.993L18 3v2a1 1 0 0 1 .117 1.993L18 7a1 1 0 0 1-1 1H6a2 2 0 0 1-1.995-1.85L4 5.998 2.5 6a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5L4 1.999l.005-.148A2 2 0 0 1 6 0h11Zm0 1H6a1 1 0 0 0-.993.883L5 2v4a1 1 0 0 0 .883.993L6 7h11V1ZM4 2.999H3v2h1v-2Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgOverheadStorage;